import { useTranslation } from 'react-i18next';
import { OSPorStatus } from '@/hooks/useDashboard';

interface GraficoOSPorStatusProps {
  dados: OSPorStatus[];
}

/**
 * Lista de status com barras horizontais proporcionais. Mesma família visual
 * do gráfico "Clientes por Status" — totalmente monocromático.
 */
export function GraficoOSPorStatus({ dados }: GraficoOSPorStatusProps) {
  const { t } = useTranslation();

  const linhas = dados
    .filter((d) => d.quantidade > 0)
    .sort((a, b) => b.quantidade - a.quantidade);
  const total = linhas.reduce((acc, d) => acc + d.quantidade, 0);

  if (total === 0) {
    return (
      <div className="h-[200px] w-full flex items-center justify-center text-muted-foreground text-sm">
        {t('dashboard.charts.noOSFound')}
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-3">
      <div className="flex items-center justify-between text-xs text-muted-foreground">
        <span>{t('dashboard.charts.osByStatus')}</span>
        <span className="tabular-nums font-mono">
          {total} {t('dashboard.charts.quantityLabel')}
        </span>
      </div>

      <ul className="flex flex-col gap-2.5">
        {linhas.map((linha) => {
          const pct = (linha.quantidade / total) * 100;
          return (
            <li key={linha.status} className="flex flex-col gap-1">
              <div className="flex items-center justify-between text-[13px]">
                <span className="text-foreground font-medium truncate">{linha.status}</span>
                <span className="text-muted-foreground tabular-nums font-mono text-xs">
                  {linha.quantidade} · {pct.toFixed(0)}%
                </span>
              </div>
              <div className="h-1.5 w-full rounded-full bg-muted overflow-hidden">
                <div
                  className="h-full bg-foreground rounded-full transition-[width] duration-300"
                  style={{ width: `${pct}%` }}
                  aria-label={`${pct.toFixed(0)}%`}
                />
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
